<div class="coverage-selector">
    <!-- Dropdown for adding new coverages -->
    <div class="d-flex gap-2">
        <div class="flex-grow-1">
            <ng-select [items]="availableCoverages" [multiple]="false" [loading]="loading" bindLabel="name"
                bindValue="id" [formControl]="coverageToAddControl" placeholder="Agregar cobertura...">
                <!-- Use a template to hide options that are already selected -->
                <ng-template ng-option-tmp let-item="item" let-item$="item$">
                    <div [class.disabled-option]="selectedCoverageIds.includes(item.id)">
                        <strong>{{ item.name }}</strong>
                        <small class="text-muted ms-1">({{ item.coverageCode }})</small>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <button type="button" class="btn btn-outline-colonial" (click)="openCoverageModal()" [disabled]="disabled"
            title="Crear nueva cobertura">
            <span class="material-symbols-outlined">add</span>
        </button>
    </div>

    <!-- Coverage Modal for creating new coverages -->
    <app-coverage-modal [isVisible]="showCoverageModal" (closed)="onCoverageModalClosed($event)">
    </app-coverage-modal>

    <!-- List of selected coverages with configuration -->
    <div class="selected-coverages mt-3" *ngIf="selectedCoverages.length > 0">
        <app-coverage-item *ngFor="let coverage of selectedCoverages; let i = index; trackBy: trackByIndex"
            [coverage]="coverage" [coverageName]="getCoverageName(coverage.coverageId)"
            [coverageCode]="getCoverageCode(coverage.coverageId)" [availableCurrencies]="availableCurrencies"
            [disabled]="disabled" [formulaId]="formulaId" (coverageChange)="onCoverageItemChange(i, $event)"
            (remove)="removeCoverage(i)">
        </app-coverage-item>
    </div>

    <div *ngIf="selectedCoverages.length === 0 && !showCoverageModal"
        class="text-center p-4 border rounded bg-light text-muted">
        No hay coberturas seleccionadas. Agrega una arriba.
    </div>
</div>